import { defineMessages } from 'react-intl';

export default defineMessages({
  noData: { defaultMessage: 'No data available for this asset' },
});
